import { ChainId } from '@ourzora/chains'
import { CHAIN_TO_ADDRESSES_MAP } from '@uniswap/sdk-core'
import { base, baseSepolia } from 'viem/chains'
import { cleanAddress, LowercaseAddress } from '../../addresses'
import { assert } from '../../utils/assert'
import { abi } from './abi'

const baseAddress = CHAIN_TO_ADDRESSES_MAP[base.id].v4PoolManagerAddress
assert(baseAddress)

const baseSepoliaAddress = CHAIN_TO_ADDRESSES_MAP[baseSepolia.id].v4PoolManagerAddress
assert(baseSepoliaAddress)

export const UniswapV4PoolManager = {
  abi,
  address: {
    [base.id]: cleanAddress(baseAddress),
    [baseSepolia.id]: cleanAddress(baseSepoliaAddress),
  } satisfies Partial<Record<ChainId, LowercaseAddress>>,
} as const
